import {
    Carousel,
    CarouselContent,
    CarouselItem, CarouselNavigation,
} from '../../../components/core/carousal/Carousal.tsx';



export default function ImageCarousal({ images }: { images: string[] }) {
    return (
        <div className='relative w-full px-4'>
            <Carousel>
                <CarouselContent className='-ml-4 mt-2'>
                    {images.map((imageUrl, index) => {
                        return (
                            <CarouselItem key={index} className='basis-1/3 sm:basis-1/4 pl-0.5 '>
                                <div
                                    className='flex aspect-square items-center justify-center border border-zinc-200 rounded-md'
                                    style={{ backgroundImage: `url(${imageUrl})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}>
                                </div>
                            </CarouselItem>
                        )
                    })}

                </CarouselContent>

                {images.length > 1 && <CarouselNavigation
                    className='absolute -bottom-14 left-auto top-auto w-full justify-end gap-2'
                    classNameButton='bg-zinc-800 *:stroke-zinc-50 dark:bg-zinc-200 dark:*:stroke-zinc-800'
                    alwaysShow
                />}
            </Carousel>
        </div>
    )


}